import { useContext, useEffect, useState } from "react";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { useNavigate } from "react-router-dom";
import { Step } from "../../models/Step";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { Amounts } from "./Amount";
import { thousandNumberSeperator } from "../../utils/format";
import { Range } from "react-range";
import { BackButton } from "../../components/BackButton";

const OtherAmountStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();
  const [values, setValues] = useState<number[]>([175000]);

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'OtherAmount' } });
    dispatch({ type: "set_step", step: Step.OtherAmount });
    scrollToTopOfContent();
  }, []);

  useEffect(() => {
    if (state.amount) {
      setValues([state.amount]);
    }
  }, [state]);

  const handleClick = () => {
    const amount = values[0];
    dispatch({ type: "set_amount", values: amount });
    navigate(`/produkt/${amount}`);
  };

  return (
    <>
      <h2>Hvor meget vil du låne?</h2>

      <div className="mt-20">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Range
            label="Select your value"
            step={5000}
            min={Math.min(...Amounts)}
            max={Math.max(...Amounts)}
            values={values}
            onChange={(values) => setValues(values)}
            renderTrack={({ props, children }) => (
              <div
                onMouseDown={props.onMouseDown}
                onTouchStart={props.onTouchStart}
                style={{
                  ...props.style,
                  height: "36px",
                  display: "flex",
                  width: "100%",
                }}
              >
                <div
                  ref={props.ref}
                  style={{
                    height: "5px",
                    width: "100%",
                    borderRadius: "4px",
                    background: "#43bbaf",
                    alignSelf: "center",
                  }}
                >
                  {children}
                </div>
              </div>
            )}
            renderThumb={({ props, isDragged }) => (
              <div
                {...props}
                key={props.key}
                style={{
                  ...props.style,
                  height: "42px",
                  width: "42px",
                  borderRadius: "4px",
                  backgroundColor: "#FFF",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 2px 6px #AAA",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-40px",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "14px",
                    fontFamily: "Arial,Helvetica Neue,Helvetica,sans-serif",
                    padding: "4px",
                    borderRadius: "4px",
                    backgroundColor: "#43bbaf",
                  }}
                >
                  {/* {values[0].toFixed(1)} */}
                  <div className="whitespace-nowrap">
                    {thousandNumberSeperator(values[0])} kr.
                  </div>
                </div>
                <div
                  style={{
                    height: "16px",
                    width: "5px",
                    backgroundColor: isDragged ? "#548BF4" : "#CCC",
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className="flex text-xs font-semibold mt-3">
          <div className="flex-1 text-lg text-regal-darkestblue">
            {thousandNumberSeperator(Math.min(...Amounts))} kr.
          </div>
          <div className="flex-1 text-right text-lg text-regal-darkestblue">
            {thousandNumberSeperator(Math.max(...Amounts))} kr.
          </div>
        </div>

        <div className="container-btn">
          <BackButton />
          <button className="btn-next" onClick={handleClick}>
            Næste
          </button>
        </div>
      </div>
    </>
  );
};

export default OtherAmountStep;
